import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDatepickerNavigateEvent, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { GMonService } from "../_services/gmon-service/gmon.service";
import { DateUtils } from "../_commons/date-utils";
import { Config } from "../config";
import { GMonInput } from '../_models/gmon-input';
import { GuiService } from '../_services/gui-service/gui.service';
import { NgxSpinnerService, } from 'ngx-spinner';
import { InputService } from '../_services/input/input.service';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from '../_services/configuration/configuration.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-gmon-dialog',
  templateUrl: './gmon-dialog.component.html',
  styleUrls: ['./gmon-dialog.component.css'],

})
export class GmonDialogComponent {
  private numberOfDay: number;
  // fromDate: NgbDateStruct = null;
  // toDate: NgbDateStruct = null;
  fromDate = this.inputService.getDefaultDate("fromDateDefault");
  toDate = this.inputService.getDefaultDate("toDateDefault");

  dateSelectedYear: number;

  showOGMBox = false;
  ogmEnabled: boolean = false;
  voltageQuantilesEnabled: boolean = false;

  public datesWithMeasurements: Array<String> = new Array<String>();
  private topology: any;

  public oneDayDatePicker: boolean = false;
  public oneWeekDatePicker: boolean = false;
  public customDatePicker: boolean = true;
  selectDateForm: FormGroup;

  private enableDataAvailabilityCheck: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private gMonService: GMonService,
    private guiService: GuiService,
    private inputService: InputService,
    private dateUtils: DateUtils,
    private spinner: NgxSpinnerService,
    private configurationService: ConfigurationService,
    private fb: FormBuilder
  ) {
    //this.topology = this.configurationService.getConfiguration().TOPOLOGY;
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    this.showOGMBox = this.configurationService.getConfiguration().APPLICATIONS.showOGMBox;
    this.selectDateForm = this.fb.group({
      selectedDateOptions: ['3']
    });
    this.enableDataAvailabilityCheck = this.configurationService.getConfiguration().enableDataAvailabilityCheck;
  }

  runGMon() {
    console.log(this.fromDate);
    console.log(this.toDate);
    let fromDate; let toDate;
    if(this.oneDayDatePicker == true){
      let today = new Date();
      toDate = this.dateUtils.dateStringToString1(parseInt(today.toISOString().slice(0, 4)), parseInt(today.toISOString().slice(5,7)), parseInt(today.toISOString().slice(8,10)));
      let fromDateOneDayInterval = new Date();
      fromDateOneDayInterval.setDate(today.getDate() - 1);
      fromDate = this.dateUtils.dateStringToString1(parseInt(fromDateOneDayInterval.toISOString().slice(0, 4)), parseInt(fromDateOneDayInterval.toISOString().slice(5,7)), parseInt(fromDateOneDayInterval.toISOString().slice(8,10)));
    }
    if(this.oneWeekDatePicker == true){
      let today = new Date();
      toDate = this.dateUtils.dateStringToString1(parseInt(today.toISOString().slice(0, 4)), parseInt(today.toISOString().slice(5,7)), parseInt(today.toISOString().slice(8,10)));
      let fromDateOneDayInterval = new Date();
      fromDateOneDayInterval.setDate(today.getDate() - 7);
      fromDate = this.dateUtils.dateStringToString1(parseInt(fromDateOneDayInterval.toISOString().slice(0, 4)), parseInt(fromDateOneDayInterval.toISOString().slice(5,7)), parseInt(fromDateOneDayInterval.toISOString().slice(8,10)));
    }
    if(this.customDatePicker == true){
      if (this.fromDate.year && this.fromDate.month && this.fromDate.day &&
        this.toDate && this.toDate.month && this.toDate.day) {
        fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
        toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);
        this.inputService.saveDefaultDate("fromDateDefault", this.fromDate);
        this.inputService.saveDefaultDate("toDateDefault", this.toDate);
        this.numberOfDay = this.inputService.getNumberOfDays(fromDate, toDate);
        this.inputService.saveNumberOfDays('numberOfDayGmon', this.numberOfDay);
      } else {
        return;
      }
    }
    const gmonInput: GMonInput = new GMonInput();
    gmonInput.topologyId = this.topology.topologyId;
    gmonInput.ogmEnabled = this.ogmEnabled;
    gmonInput.startDate = DateUtils.stringLocalDateToUTC(fromDate);
    gmonInput.endDate = DateUtils.stringLocalDateToUTC(toDate);
    gmonInput.voltageQuantilesEnabled = this.voltageQuantilesEnabled;
    console.log(gmonInput);

    this.guiService.runGMon(gmonInput).subscribe(() => {
      this.activeModal.dismiss('gmonStarted');
    });
  }

  isGMonRunning(): boolean {
    return this.gMonService.isGMonRunning();
  }

  onNavigateDate(event: NgbDatepickerNavigateEvent) {
    const nextYear: number = event.next.year;
    if (!this.dateSelectedYear || nextYear != this.dateSelectedYear) {
      this.dateSelectedYear = nextYear;
      let offset = new Date().getTimezoneOffset();

      if (this.enableDataAvailabilityCheck) {
        this.guiService.getMeasurementData(nextYear, offset).subscribe((dates: Array<String>) => {
          console.log(dates);
          this.datesWithMeasurements = dates;
        }), (error) => {
          error.console.error();
        };
      }
    }
  }


  isRange(date: NgbDateStruct) {
    let month: string = "" + date.month;
    if (month.length == 1) {
      month = "0" + month;
    }
    let day: string = "" + date.day;
    if (day.length == 1) {
      day = "0" + day;
    }

    const currentDate: string = date.year + "-" + month + "-" + day;
    if (this.datesWithMeasurements) {
      if (this.datesWithMeasurements.indexOf(currentDate) == -1) {
        return false;
      } else {
        return true;
      }
    }
  }


  /**
   * Check selected date range
   * The method return true when the "fromDate" is previous of "toDate", 
   * and return false in all other cases
   * @returns Boolean (true/false)
   */
  checkSelectedRangeDate() {
    if(this.oneDayDatePicker == true || this.oneWeekDatePicker == true){
      return false;
    }
    else if (this.fromDate && this.toDate) {
      let fDate = new NgbDate(this.fromDate.year, this.fromDate.month, this.fromDate.day)
      let tDate = new NgbDate(this.toDate.year, this.toDate.month, this.toDate.day)
      if (tDate.after(fDate) || fDate.equals(tDate)) {
        return false;
      }
      else{
        return true;
      }
    }
    else {
      return true;
    }
  }

  checkSelectedDatePicker(): void{
    if(this.selectDateForm.get('selectedDateOptions').value == 1){
      this.oneDayDatePicker = true;
      this.oneWeekDatePicker = false;
      this.customDatePicker = false;
    }else if(this.selectDateForm.get('selectedDateOptions').value == 2){
      this.oneDayDatePicker = false;
      this.oneWeekDatePicker = true;
      this.customDatePicker = false;
    }else if (this.selectDateForm.get('selectedDateOptions').value == 3){
      this.oneDayDatePicker = false;
      this.oneWeekDatePicker = false;
      this.customDatePicker = true;
    }
  }
}

